var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_177_5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_177_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0H0V19H19V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_177_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.875 0C11.2182 0 10.6875 0.530665 10.6875 1.1875C10.6875 1.84434 11.2182 2.375 11.875 2.375H14.9439L7.47384 9.84884C7.00997 10.3127 7.00997 11.066 7.47384 11.5299C7.93768 11.9938 8.69101 11.9938 9.15488 11.5299L16.625 4.05607V7.125C16.625 7.78183 17.1557 8.3125 17.8125 8.3125C18.4693 8.3125 19 7.78183 19 7.125V1.1875C19 0.530665 18.4693 0 17.8125 0H11.875ZM2.96875 1.1875C1.32852 1.1875 0 2.51602 0 4.15625V16.0313C0 17.6715 1.32852 19 2.96875 19H14.8438C16.484 19 17.8125 17.6715 17.8125 16.0313V11.875C17.8125 11.2182 17.2818 10.6875 16.625 10.6875C15.9682 10.6875 15.4375 11.2182 15.4375 11.875V16.0313C15.4375 16.3578 15.1703 16.625 14.8438 16.625H2.96875C2.64219 16.625 2.375 16.3578 2.375 16.0313V4.15625C2.375 3.82969 2.64219 3.5625 2.96875 3.5625H7.125C7.78183 3.5625 8.3125 3.03183 8.3125 2.375C8.3125 1.71816 7.78183 1.1875 7.125 1.1875H2.96875Z",
    fill: "black",
    fillOpacity: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_177_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.96ea4d8eba7b37057b5b37b46895dba9.svg";
export { ForwardRef as ReactComponent };